import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown } from "../../../common/component/Index";
import FareRule from './../../../../../models/FareRule';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import { PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';

const ListCols = ['airlineCode', 'className', 'cancellationRefund', 'timeChange', 'itineraryChange', 'passengerInfoChange', 'remarks', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new FareRule());

class FareRuleList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                airlineCode: {
                    key: 'airlineCode',
                    render: (text, record) => <p>{text}</p>
                },
                className: {
                    key: 'className',
                    render: (text, record) => <p>{text}</p>
                },
                cancellationRefund: {
                    key: 'cancellationRefund',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={400}
                    overlayClassName={'max-width-500'} />
                },
                timeChange: {
                    key: 'timeChange',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={400}
                    overlayClassName={'max-width-500'} />
                },
                itineraryChange: {
                    key: 'itineraryChange',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={400}
                    overlayClassName={'max-width-500'} />
                },
                passengerInfoChange: {
                    key: 'passengerInfoChange',
                    render: (text, record) => <p>{text}</p>
                },
                remarks: {
                    key: 'remarks',
                    render: (text, record) => <p>{text}</p>
                },
                translations: {
                    key: 'languageCode',
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, fareRules } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                scroll={{ x: 1300 }}
                tableKey="fare-rules-list"
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(fareRules || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'fareRule'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                onColumnVisibleChange={this.onColumnVisibleChange}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeFareRule= () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.fareRule.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeFareRule,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.FARE_RULES.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    getTableColumns() {
        return Func.getTitleTable(['airlineCode', 'className', 'classCode', 'cancellationRefund', 'timeChange', 'itineraryChange', 'passengerInfoChange', 'remarks', 'translations'], ['action'], []);
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }


}

export default withTranslation()(FareRuleList);
